import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AreasService } from "../../master-services/area-services/areas.service";
import swal from "sweetalert2";
import { Console, error } from "console";
import { OrderService } from "../../master-services/order-service/orderservice.service";
import {
  NgbCalendar,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-master-imports",
  templateUrl: "./master-imports.component.html",
  styleUrls: [
    "./master-imports.component.scss",
    "../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class MasterimportsComponent implements OnInit {
  ////Comienza Espacio para declaraciones /////
  public filterCriteria = {
    importOrderConsecutive: "",
    startDate: "",
    endDate: "",
    orderStatus: "",
    priceList: "",
  };

  priceListMap: { [key: number]: string } = {
    0: "Seleccione origen",
    2: "USA",
    3: "ESPAÑA",
    4: "BELGICA",
    5: "SERVICIO TERCERO",
    6: "REPUESTO NACIONAL",
    7: "SIN",
    8: "USA FPE",
    9: "FLORIDA",
    10:"KANSAS",
    11: "MPE",
  };

  stateListMap: { [key: number]: string } = {
    0: "En canasta",
    1: "Llego el pedido",
    2: "Despachado",
  };

  priceListArray: { key: number; value: string }[] = [];
  consecutive: any;
  now: any;
  user: any;
  selectedOriginId: number = 0;
  state: number = 0;
  import_order: any;
  filteredOrders: any;
  emailLogist: any;
  estimateDeliveryDate: any;
  newEstimateDeliveryDate = null;
  newEstimateReason = '';
  importIdUpdating = null;

  ////Termina Espacio para declaraciones /////
  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private orderservice: OrderService,
    private calendar: NgbCalendar
  ) {
    this.index();
  }
  ngOnInit() {}

  index() {
    //Obtencion de data
    this.getConsecutive();
    this.getImportOrder();

    /// Formateo a objeto para lista de precios
    this.priceListArray = Object.keys(this.priceListMap).map((key) => ({
      key: +key, // Convertir la clave a número
      value: this.priceListMap[+key],
    }));

    ///Obtener fecha y usuario
    var date = new Date();
    var day = (date.getDate() < 10 ? "0" : "") + date.getDate();
    let month = (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);
    var year = date.getFullYear();
    this.now = year + "-" + month + "-" + day;
    this.user = localStorage.getItem("username");
  }

  ///********Comienza espacio para funciones

  ////Formateo de datos
  go_orderservice() {
    this.router.navigateByUrl("erp/serviceorder");
  }
  getPriceListName(priceList: number): string {
    return this.priceListMap[priceList] || "Desconocido";
  }

  getStateListName(priceList: number): string {
    return this.stateListMap[priceList] || "Desconocido";
  }

  ///****Obtencion y creacion de data--- De aca para abajo
  getConsecutive() {
    this.orderservice
      .getimportsconsecutive()
      .then((data) => {
        const resp: any = data;
        //console.log(data);
        swal.close();
        this.consecutive = resp.data;
        var date = new Date();

        let now = date.getFullYear();

        // 01, 02, 03, ... 10, 11, 12
        let month =
          (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);

        let yearCosecutive = date.getFullYear().toString().substring(2, 4);
        this.consecutive = Number(this.consecutive.consecutive) + 1;
        this.consecutive = Number(
          yearCosecutive.toString() +
            month.toString() +
            "0" +
            this.consecutive.toString()
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }
  async updateImportOrderConsecutive() {
    console.log("Actualizando el consecutivo desde la creación del detalle...");
    try {
      const data: any = await this.orderservice.updateimportorderConsecutive();
      console.log("Consecutivo actualizado", data);
      //window.location.reload();
      this.index();
    } catch (error) {
      console.error("Error al actualizar el consecutivo", error);
    }
  }

  createimportOrder() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    console.log("hola aca pasare la data");
    const data = {
      import_order_consecutive: this.consecutive,
      order_date: this.now,
      created_for: this.user,
      selected_origin_id: this.selectedOriginId,
      product_arrived: this.state,
      estimateDeliveryDate:this.estimateDeliveryDate
    };

    //console.log(data);
    
    this.orderservice.createImportOrder(data).then((data) => {
      if (data && typeof data === "object" && "success" in data) {
        this.updateImportOrderConsecutive();

        console.log("Se ha creado el post", data);
        swal({
          title: "Pedido de Importacion creada correctamente",
          type: "success",
        });
      } else {
        console.log("Error al crear POSTLOGIST:", data);
        // Manejo Adicional de errores
      }
    });
    
  }

  getImportOrder() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice
      .getImportOrder()
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.import_order = resp.data;
        console.log("Data recibida de Importorders:", this.import_order);

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }


  sendEmailArrivedProducts(import_order_consecutive) {
    //Indico el email de notificacion (cartera y el correo cliente)

    const MailData = this.import_order.find(
      (order) => order.import_order_consecutive === import_order_consecutive
    );
    this.emailLogist = "auxlogistica@montacargasmaster.com.co";
   

    const updateData: any = {
      emails: [this.emailLogist],

      orderData: MailData,
    };
    console.log("Holaaa desde donde mando correo de separacion", updateData);
    this.orderservice
      .sendEmailArrivedProducts(import_order_consecutive, updateData)
      .then(() => {
        console.log("se ah enviado el correo");
        swal({
          title: "Se ha Notificado a logistica",
          type: "success",
        });

        swal.close();
        this.index();
      })
      .catch((error) => {
        // Manejar el error en caso de que la promesa sea rechazada
        console.error("Error al enviar notificaciones por correo:", error);
      });
  }

  viewOrderBasket(id: number) {
    console.log("holaaa Aca pasare consecutivo de importacion", id);
    this.router.navigate([`/erp/import_order_detail`, id]);
  }



  go_basket() {
    this.router.navigateByUrl("erp/import_basket");
  }
  go_backOrder() {
    this.router.navigateByUrl("erp/import_backorder");
  }
  
  handleOrderArrival(orderId: number, import_order_consecutive: number) {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    console.log(`Pedido con ID ${orderId} ha llegado: 1`);
    const updatedOrder = this.import_order.find(
      (order) => order.id === orderId
    );

    if (updatedOrder) {
      const data = {
        id: updatedOrder.id,
        import_order_consecutive: updatedOrder.import_order_consecutive,
        order_date: updatedOrder.order_date,
        created_for: updatedOrder.created_for,
        selected_origin_id: updatedOrder.selected_origin_id,
        product_arrived: 1, //Se actualiza el pedido a 1 para marcar q lllego
      };
      console.log("data para actualizar", data);
      this.orderservice.updateImportOrder(orderId, data).then((data) => {
        if (data && typeof data === "object" && "success" in data) {
          console.log("Se ha creado la actualizacion de arrivo", data);
          // swal({
          //   title: "Se ha cambiado el estado del pedido",
          //   type: "success",
          // });
          // this.index();
        } else {
          console.log("Error al crear POSTLOGIST:", data);
          // Manejo Adicional de errores
        }
      });

      ///Aca actualizo detail
      const dataDetail = { product_arrived: 1 };
      this.orderservice
        .updateImportOrderDetail(
          updatedOrder.import_order_consecutive,
          dataDetail
        )
        .then((data) => {
          if (data && typeof data === "object" && "success" in data) {
            console.log(
              "Se ha creado la actualizacion de imports Detail",
              data
            );
            swal({
              title: "Se ha cambiado el estado del pedido",
              type: "success",
            });
            console.log("Acaaaa consecutibvo", import_order_consecutive);
            this.sendEmailArrivedProducts(import_order_consecutive);
          } else {
            console.log("Error al crear POSTLOGIST:", data);
            // Manejo Adicional de errores
          }
        });
    }
  }

  ////7Esta lleva ventana emergente de confirmacion
  handleOrderArrival2(orderId: number, import_order_consecutive: number) {
    if (window.confirm("¿Estás seguro de marcar este pedido como llegado? Esta acción no se puede deshacer.")) {
      const now = new Date();
        const localISOTime = new Date(
          now.getTime() - now.getTimezoneOffset() * 60000
        ).toISOString();
        
      swal({
        title: "Obteniendo información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
        

        console.log(`Pedido con ID ${orderId} ha llegado: 1`);
        const updatedOrder = this.import_order.find(
          (order) => order.id === orderId
        );

        if (updatedOrder) {
          const data = {
            id: updatedOrder.id,
            import_order_consecutive: updatedOrder.import_order_consecutive,
            order_date: updatedOrder.order_date,
            created_for: updatedOrder.created_for,
            selected_origin_id: updatedOrder.selected_origin_id,
            product_arrived: 1,
            date_arrived: localISOTime,
          };
          console.log("data para actualizar", data);
          
          this.orderservice.updateImportOrder(orderId, data).then((data) => {
            if (data && typeof data === "object" && "success" in data) {
              console.log("Se ha creado la actualización de arribo", data);
            } else {
              console.log("Error al crear POSTLOGIST:", data);
            }
          });

          const dataDetail = { product_arrived: 1 };
          this.orderservice
            .updateImportOrderDetail(
              updatedOrder.import_order_consecutive,
              dataDetail
            )
            .then((data) => {
              if (data && typeof data === "object" && "success" in data) {
                console.log("Se ha creado la actualización de imports Detail", data);
                
                console.log("Consecutivo", import_order_consecutive);
                this.sendEmailArrivedProducts(import_order_consecutive);
              } else {
                console.log("Error al crear POSTLOGIST:", data);
              }
            });
            
        }
    } else {
        console.log("Operación cancelada por el usuario.");
    }
  }

  toggleUpdateEstimateDate(importId: number = null) {
    if (this.importIdUpdating) {
      this.importIdUpdating = null;
      this.newEstimateDeliveryDate = null;
      this.newEstimateReason = '';
    } else {
      this.importIdUpdating = importId;
    }
  }

  updateEstimateDate(importId: number) {
    if (this.newEstimateDeliveryDate) {
      const newEstimate = {
        estimateDeliveryDate: this.newEstimateDeliveryDate,
        reason: this.newEstimateReason
      }
  
      swal({
        title: "Actualizando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
      
      this.orderservice.updateImportOrderEstimateDate(importId, newEstimate)
        .then((data) => {
          if (data && typeof data === "object" && "success" in data) {
            console.log("Se ha actualización de la fecha estimada", data);
            this.toggleUpdateEstimateDate(importId);
            this.getImportOrder();
            swal.close();
          } else {
            console.log("Error al actualizar fecha estimada:", data);
          }
        });
    } else {
      swal({
        title: "Debe ingresar una fecha",
        text: "Error",
        type: "error",
      });
    }
  }

  sendClearedCustomsEmail(importId: number) {
    swal({
      title: "Enviando correo ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.orderservice.sendImportOrderEmailClearedCustoms(importId)
      .then(() => {
        swal.close();
      });
  }

  applyFilters() {
      
      console.log("Acaa funcion para pasar y aplicar los filtros")
      console.log("Acaa funcion para pasar y aplicar los filtros",this.filterCriteria)
      
      const queryParams = new URLSearchParams();
  
      if (
        !this.filterCriteria.priceList &&
        !this.filterCriteria.importOrderConsecutive &&
        !this.filterCriteria.startDate &&
        !this.filterCriteria.endDate &&
        !this.filterCriteria.orderStatus 
      ) {
        console.log("Debe seleccionar al menos un criterio de filtrado.");
        alert("Debe seleccionar al menos un criterio de filtrado.");
        return; // Salir de la función si no hay criterios de filtrado
      }
  
      // Log para ver el estado inicial de filterCriteria
      console.log("Estado inicial de filterCriteria:", this.filterCriteria);
      
  
      if (this.filterCriteria.importOrderConsecutive) {
        queryParams.append(
          "importOrderConsecutive",
          this.filterCriteria.importOrderConsecutive
        );
        console.log(
          "Filtro añadido - orderServiceConsecutive:",
          this.filterCriteria.importOrderConsecutive
        );
      }
  
      if (this.filterCriteria.priceList) {
        queryParams.append("priceList", this.filterCriteria.priceList);
        console.log(
          "Filtro añadido - priceList:",
          this.filterCriteria.priceList
        );
      }
  
      if (this.filterCriteria.startDate) {
        queryParams.append("startDate", this.filterCriteria.startDate);
        console.log("Filtro añadido - startDate:", this.filterCriteria.startDate);
      }
  
      if (this.filterCriteria.endDate) {
        queryParams.append("endDate", this.filterCriteria.endDate);
        console.log("Filtro añadido - endDate:", this.filterCriteria.endDate);
      }
      if (this.filterCriteria.orderStatus) {
        queryParams.append("orderStatus", this.filterCriteria.orderStatus);
        console.log(
          "Filtro añadido - orderStatus:",
          this.filterCriteria.orderStatus
        );
      }
  
      
  
      const queryString = queryParams.toString();
  
      // Log para ver la cadena de consulta resultante
      console.log("Cadena de consulta (queryString):", queryString);
  
      // Simulación de la llamada al servicio, con log de los resultados
      console.log("Llamada al servicio con queryString:", queryString);
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
      
   

  
       this.orderservice
         .getImportOrderApplyFilters(queryString)
         .then((data) => {
           const resp: any = data;
           this.import_order = resp.data;
           console.log(
             "Data recibida de órdenes Filtradas:",
             resp
           );
           console.log(
            "Data recibida de órdenes en variable:",
            this.import_order
          );
     
           swal.close();
         })
         .catch((error) => {
           console.log(error);
         });
        
    }





  

  

  

  ////
}



// WEBPACK FOOTER //
// ./src/app/master/master-imports/master-imports.component.ts